<script lang="ts">
import type { TIconValue } from '@/utils/helper-objects'
import { IconBadge } from '@goodlifeplus/design-system/components'
import {
  NamedThemeColors,
  type TNamedThemeColorValue,
} from '@goodlifeplus/design-system/theme'
import { kebabCase } from 'change-case'
import { type PropType, defineComponent } from 'vue'

/**
 * CardHeader
 */
export default defineComponent({
  components: {
    IconBadge,
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    icon: {
      type: String as PropType<TIconValue>,
      default: null,
    },
    iconColor: {
      type: String as PropType<TNamedThemeColorValue>,
      default: NamedThemeColors.Primary,
    },
    truncateSubtitle: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {
      kebabCase,
    }
  },
})
</script>

<template>
  <div class="flex items-center gap-x-3" :class="kebabCase(title ?? '')">
    <div v-if="$slots.start">
      <slot name="start"></slot>
    </div>
    <IconBadge v-else-if="icon" :icon :color="iconColor" />
    <div class="flex-1 min-w-0">
      <div class="text-xl font-bold truncate">
        {{ title }}
      </div>
      <div v-if="subtitle" :class="{ truncate: truncateSubtitle }">
        {{ subtitle }}
      </div>
    </div>
    <div v-if="$slots.end" class="card-header__end">
      <slot name="end"></slot>
    </div>
  </div>
</template>
